var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCivitai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "92.000000pt",
    height: "92.000000pt",
    viewBox: "0 0 92.000000 92.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,92.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417 884 c-20 -13 -55 -34 -77 -45 -22 -12 -37 -26 -33 -32 3 -6 1 -7 -5 -3 -6 4 -61 -22 -122 -56 l-110 -63 0 -227 0 -226 183 -105 c100 -58 189 -109 198 -112 10 -4 86 35 205 103 l189 109 3 229 2 229 -172 100 c-95 54 -180 99 -190 99 -9 0 -16 4 -15 9 4 19 -19 15 -56 -9z m132 -274 c75 -42 81 -47 81 -77 0 -32 -2 -33 -38 -33 -21 0 -60 11 -86 24 l-48 24 -34 -20 c-31 -18 -34 -24 -34 -67 0 -43 3 -48 36 -66 36 -19 36 -19 75 3 24 14 55 22 83 22 44 0 46 -1 46 -30 0 -26 -8 -34 -77 -74 -43 -25 -84 -46 -91 -46 -7 0 -48 21 -92 46 l-80 47 0 98 0 98 83 50 c45 27 85 48 89 48 3 -1 42 -22 87 -47z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCivitai);
export default __webpack_public_path__ + "static/media/civitai.cbcc068d2a2807355ddfdf7bcbb5ee74.svg";
export { ForwardRef as ReactComponent };